var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"course-share"},[_c('Button',{staticClass:"course-share-btn",attrs:{"icon":"share-o","round":"","type":"danger"},on:{"click":function($event){_vm.shareCourse()}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }